<template>
  <div class="candidate-container">
    <VContainer class="py-0">
      <AppPreloader v-if="loading" />
      <VAlert v-else-if="sharedLinkError.errorMessage" type="error">
        {{ sharedLinkError.errorMessage }}
      </VAlert>
      <Candidate v-else :company="company" :candidate="candidate" :vacancy="vacancy" />
    </VContainer>
  </div>
</template>

<script>
import ApiMixin from '../mixins/ApiMixin';
import httpClient from '../api';
import Candidate from '../components/Candidate/Candidate.vue';
import AppPreloader from '../components/AppPreloader.vue';

export default {
  name: 'CandidateSharedLink',
  components: {
    Candidate,
    AppPreloader,
  },
  mixins: [ApiMixin],
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tokenInfo: null,
      company: null,
      candidate: null,
      vacancy: null,
      sharedLinkError: this.getInitialErrorData(),
      loading: true,
    };
  },
  computed: {
    pageTitle() {
      if (this.candidate) {
        return `${this.$t('candidate')} ${this.candidate.firstName} ${this.candidate.lastName}`;
      }

      return this.$t('candidate');
    },
  },
  async created() {
    httpClient.defaults.headers.common['X-Candidate-Public-Authorization'] = this.token;
    delete httpClient.defaults.headers.common['X-Candidate-Authorization'];

    await this.fetch();
  },
  methods: {
    async fetchPublicTokenInfo() {
      this.tokenInfo = await this.$store.dispatch('candidate/fetchPublicTokenInfo', this.token);
    },
    async fetchCandidate() {
      this.candidate = await this.$store.dispatch('candidate/fetchCandidateByToken', this.token);
    },
    async fetchVacancy(id) {
      this.vacancy = await this.$store.dispatch('vacancy/fetchVacancyById', id);
    },
    async fetchCompany(id) {
      this.company = await this.$store.dispatch('company/fetchCompanyById', id);
    },
    async fetch() {
      this.withApiErrorHandling(async () => {
        await this.fetchPublicTokenInfo();

        await Promise.all([
          this.fetchCompany(this.tokenInfo.companyId),
          this.fetchVacancy(this.tokenInfo.vacancyId),
          this.fetchCandidate(this.tokenInfo.candidateId),
        ]);
      }, 'sharedLinkError', 'loading');
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  candidate: Candidate
</i18n>

<i18n locale="ru" lang="yaml">
  candidate: Кандидат
</i18n>

<style lang="scss" scoped>
@media #{map-get($display-breakpoints, 'md-and-up')} {
  .candidate-container {
    display: flex;
    min-height: calc(100vh - 250px);
    background: linear-gradient(to right, white 50%, #f5f5f5 50%);
  }
}
</style>
